import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { useEffect, useRef } from "react";
import i18n from "./i18n";
import { isNativeAppRuntime } from "./utils/nativeApp";
import { recordDistributorShareBrowse } from "./api/member";
import { readReferralCode } from "./utils/memberSession";
import AgeGate from "./components/AgeGate";

function ReferralAttributionTracker() {
  const location = useLocation();
  const recordedEntriesRef = useRef(new Set<string>());

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const referralCode = (params.get("ref") || params.get("shareCode") || "").trim().toUpperCase();
    if (!referralCode) return;

    // readReferralCode also persists the URL value for registration flows.
    readReferralCode();
    const pathDramaID = location.pathname.match(/^\/watch\/(\d+)/)?.[1] || "";
    const dramaId = Number(pathDramaID || params.get("video") || 0) || 0;
    const entryKey = `${referralCode}:${dramaId}`;
    if (recordedEntriesRef.current.has(entryKey)) return;
    recordedEntriesRef.current.add(entryKey);

    void recordDistributorShareBrowse({
      shareCode: referralCode,
      dramaId,
      channel: isNativeAppRuntime() ? "app" : "web",
    }).catch(() => undefined);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  isNativeAppRuntime();

  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <div className="dark min-h-screen bg-background-950 text-foreground-50">
        <BrowserRouter basename={__BASE_PATH__}>
          <ReferralAttributionTracker />
          <AppRoutes />
          <AgeGate />
        </BrowserRouter>
      </div>
    </I18nextProvider>
  );
}

export default App;
